import React, { useEffect, useState } from "react";
import { Button, Card, Col, Row, Select, Input, Modal, DatePicker, Space, Divider, Form } from "antd";
import { SearchOutlined, ArrowRightOutlined, CodeSandboxOutlined, RedoOutlined } from "@ant-design/icons";
import PageHeader from "../view/pageheader";
import { getDashboardList, getDashboardPreprcoessBox, getEventBoxCount } from "../store/reducer/dashboardSlice";
import { useSelector, useDispatch } from "react-redux";
import TableComponent from "./CustomComponents/TableComponent";
import SearchComponent from "./CustomComponents/SearchComponent";
import dayjs from "dayjs";
import { Link, useNavigate } from "react-router-dom";
import { BsBoxes, BsFillInboxesFill } from "react-icons/bs";
import { FaBoxes, FaUsersCog } from "react-icons/fa";
import { FaBoxesPacking, FaUsersRectangle } from "react-icons/fa6";
import { PiUserSquareBold } from "react-icons/pi";
import { GrUserSettings } from "react-icons/gr";
import { BiSolidUserAccount } from "react-icons/bi";
import { getEventList } from "../store/reducer/eventSlice";
import { getAllBoxes } from '../store/reducer/jobSlice'

import './dashboard.css'
const DashBoard = () => {
   const dispatch = useDispatch()
   const navigate = useNavigate();
   const { dashboardListData, dashboardPreprocessData, getEventBoxCountData } = useSelector((state) => state.dashboard)
   const { eventListData } = useSelector((state) => state.events)
   const { getAllBoxesData } = useSelector((state) => state.jobs);
   const { count: totalCount, data: tableData } = getAllBoxesData || {};
   const role_id = localStorage.getItem("role_id")
   const [selectedSpecId, setSelectedSpecId] = useState(null);
   const [searchModal, setSearchModal] = useState(false);
   const [searchText, setSearchText] = useState('');
   const [searchDate, setSearchDate] = useState(null);
   const [searchValue, setSearchValue] = useState('');
   const [clearFilter, setClearFilter] = useState(false);
   const [searchForm] = Form.useForm();
   function getData(payload = {}) {
      dispatch(getDashboardList({}));
      dispatch(getEventBoxCount({}))
      dispatch(getEventList(payload));
      dispatch(getAllBoxes(payload));
   }
   useEffect(() => {
      getData({})
   }, [])
   const eventData = (eventListData?.data || []).map((item) => ({
      label: item.eventname,
      value: item.id
   }));
   let specData = dashboardListData?.allSpecId?.map((data) => ({
      label: data?.spec_id,
      value: data?.id
   })) || []

   const handleChange = (selectedId) => {
      setSelectedSpecId(selectedId);
      dispatch(getDashboardPreprcoessBox({ id: selectedId }));
   };
   const boxStatus = [
      {
         label: 'New',
         value: 'New'
      },
      {
         label: 'InComplete',
         value: 'InComplete'
      },
      {
         label: 'Completed',
         value: 'Completed'
      },
      {
         label: 'Dispositon Completed',
         value: 'Dispositon Completed'
      },
      {
         label: 'Re Assign Spec',
         value: 'Re Assign Spec'
      }

   ]
   const handleSearch = (values) => {
      const payloadData = {
         query: values.searchText || '',
      };

      // Add pickup_date only if selected, formatting with dayjs
      if (values.searchDate) {
         payloadData.pickup_date = values.searchDate.format('MM/DD/YYYY'); // send in MM/DD/YYYY format
      }

      if (values.boxStatusValue) {
         payloadData.box_status = values.boxStatusValue;
      }

      if (values.stage) {
         payloadData.stage = values.stage
      }

      setClearFilter(true);
      getData(payloadData);
      setSearchModal(false)

      // The form fields are reset automatically on close if we call form.resetFields() in handleCancel
   };
   const handleCancel = () => {
      searchForm.resetFields();
      setSearchModal(false);
   };




   const boxColumns = [
      {
         title: 'Barcode',
         dataIndex: 'barcode',
         key: 'barcode',
         align: 'center',
      },
      {
         title: 'Spec ID',
         dataIndex: 'spec_id',
         key: 'spec_id',
         align: 'center',
      },
      {
         title: 'Spec Box No',
         dataIndex: 'spec_box_number',
         key: 'spec_box_number',
         align: 'center',

      },

      {
         title: 'Stage',
         dataIndex: 'event_stage',
         key: 'event_stage',
         align: 'center',
         render: data => {
            if (data) {
               return <span>{data}</span>
            } else {
               return <span> Prep</span>
            }

         },
      },
      {
         title: 'Box Status',
         dataIndex: 'box_status',
         key: 'box_status',
         align: 'center',
         render: (_, record) => (
            <span
               style={record.is_moved == 1 ? { color: 'red', fontWeight: 600 } : {}}
            >
               {record.is_moved == 1
                  ? record?.box_status
                     ? `${record.box_status} `
                     : ''
                  : record?.box_status || ''}
            </span>


         ),

      },

      {
         title: 'Pickup Date',
         dataIndex: 'pickup_date',
         key: 'pickup_date',
         align: 'center',
         render: (date) => {
            return date ? dayjs(date).format('MM/DD/YYYY') : 'Yet to update';
         }
      },
      {
         title: 'Box State',
         key: 'box_state',
         render: (_, record) => (
            <span
               style={record.is_moved == 1 ? { color: 'red', fontWeight: 600 } : {}}
            >
               {record.is_moved == 1
                  ? record?.box_state
                     ? `${record.box_state} - ${record.moved_spec || ''}`
                     : ''
                  : record?.box_state || ''}
            </span>


         ),
         align: 'center',
      },

      {
         title: 'Process Box',
         key: 'action',
         align: 'center',
         render: (_, record) => (
            <Space size="middle">
               {/* <Button className="primary-btn rounded-4">View</Button> */}
               <Button
                  disabled={record?.is_production == 0 || record?.box_spec?.status == 2}
                  onClick={() => {
                     navigate(`/jobs/job_event/${window.btoa(record.job_spec_id)}`, {
                        state: {
                           job_name: window.btoa(record.job_name),
                           spec_id: record?.spec_id,
                           job_barcode: record?.barcode,
                           // workflow_name: workflow_name,
                           customer_id: window.btoa(record?.user_id),
                           // workflow_id: workflow_id

                        }
                     })
                  }}
                  icon={<ArrowRightOutlined />} className="primary-btn rounded-1"></Button>
            </Space>
         ),
      }
   ]


   const handleSearchClick = () => {
      if (!searchValue.trim()) {
         // reset if empty
         getData({ query: "" });
         return;
      }

      // Find the record in your tableData that matches the entered Box Number
      const record = tableData?.find(
         (item) => String(item.barcode).toLowerCase() === searchValue.toLowerCase()
      );
      if (record) {
         // Navigate exactly like Process Box button
         navigate(`/jobs/job_event/${window.btoa(record.job_spec_id)}`, {
            state: {
               job_name: window.btoa(record.job_name),
               spec_id: record?.spec_id,
               job_barcode: record?.barcode,
               customer_id: window.btoa(record?.user_id),
            }
         });
      } else {
         // If not found, fallback to search API
         getData({ query: searchValue });
      }
   };
   return (
      <div>
         <PageHeader HeaderText="DashBoard" Breadcrumb={[{ name: "DashBoard" }]} backButtonUrl="" />
           <Card style={{ marginTop: "-28px", }}>
            <Row gutter={[16, 16]}>
               {/* First row - 4 main cards */}
               <Col span={6}>
                  <Link to={'/customers'}>  <Card className="dashboard-card gradient-red" title={
                     <span className="dashboard-title"><PiUserSquareBold size={18} /> Total Customers</span>
                  }>
                     <p className="dashboard-number">{dashboardListData?.totalCustomersData}</p>
                  </Card>
                  </Link>
               </Col>
               <Col span={6}>
                  <Link to={'/user-management'} state={{ activeTab: "2" }}>   <Card className="dashboard-card gradient-orange" title={
                     <>
                        <span className="dashboard-title"><FaUsersRectangle size={18} /> Total Production </span>
                        <span style={{ marginLeft: '50px' }} className="dashboard-title " >Users</span>
                     </>
                  }>
                     <p className="dashboard-number">{dashboardListData?.totalUserData}</p>
                  </Card>
                  </Link>
               </Col>
               <Col span={6}>
                  <Link to={'/jobs'}>   <Card className="dashboard-card gradient-blue" title={
                     <span className="dashboard-title"><BiSolidUserAccount size={18} /> Total Specs</span>
                  }>
                     <p className="dashboard-number">{dashboardListData?.totalJobsData}</p>
                  </Card></Link>
               </Col>
               <Col span={6}>
                  {
                     dashboardListData?.inprogressJobs != 0 ?
                        <Link to={'/jobs?status=3'}>   <Card className="dashboard-card gradient-purple" title={
                           <span className="dashboard-title"><FaUsersCog size={18} /> In Progress Specs</span>
                        }>
                           <p className="dashboard-number">{dashboardListData?.inprogressJobs}</p>
                        </Card>
                        </Link> :
                        <Card className="dashboard-card gradient-purple" title={
                           <span className="dashboard-title"><FaUsersCog size={18} /> In Progress Specs</span>
                        }>
                           <p className="dashboard-number">{dashboardListData?.inprogressJobs}</p>
                        </Card>
                  }
               </Col>
            </Row>

            <Divider />

            {/* Second row - 5 small cards evenly spaced */}
            <Row gutter={[16, 16]} justify="space-between">
               <Col span={4}>
                  {
                     dashboardListData.totalBoxes != 0 ?
                        <Link to={'/all-boxes'}> <Card className="dashboard-card gradient-dark" title={<span className="dashboard-title"> Total Boxes</span>}>
                           <p className="dashboard-number">{dashboardListData?.totalBoxes}</p>
                        </Card>
                        </Link> :
                        <Card className="dashboard-card gradient-dark" title={<span className="dashboard-title"> Total Boxes</span>}>
                           <p className="dashboard-number">{dashboardListData?.totalBoxes}</p>
                        </Card>
                  }
               </Col>
               <Col span={4}>
                  {dashboardListData.newBoxes != 0 ?
                     <Link to={'/all-boxes?status=New'}> <Card className="dashboard-card gradient-pink" title={<span className="dashboard-title"> New Boxes</span>}>
                        <p className="dashboard-number">{dashboardListData?.newBoxes}</p>
                     </Card>
                     </Link> :
                     <Card className="dashboard-card gradient-pink" title={<span className="dashboard-title"> New Boxes</span>}>
                        <p className="dashboard-number">{dashboardListData?.newBoxes}</p>
                     </Card>
                  }
               </Col>
               <Col span={4}>
                  {dashboardListData.incompleted != 0 ?
                     <Link to={'/all-boxes?status=InComplete'}> <Card className="dashboard-card gradient-green" title={<span className="dashboard-title"> Incomplete</span>}>
                        <p className="dashboard-number">{dashboardListData?.incompleted}</p>
                     </Card>
                     </Link>
                     : <Card className="dashboard-card gradient-green" title={<span className="dashboard-title">Incomplete</span>}>
                        <p className="dashboard-number">{dashboardListData?.incompleted}</p>
                     </Card>
                  }
               </Col>
               <Col span={4}>
                  {
                     dashboardListData.completed != 0 ?
                        <Link to={'/all-boxes?status=Completed'}> <Card className="dashboard-card gradient-yellow" title={<span className="dashboard-title"> Completed</span>}>
                           <p className="dashboard-number">{dashboardListData?.completed}</p>
                        </Card>
                        </Link> :
                        <Card className="dashboard-card gradient-yellow" title={<span className="dashboard-title"> Completed</span>}>
                           <p className="dashboard-number">{dashboardListData?.completed}</p>
                        </Card>
                  }
               </Col>
               <Col span={4}>
                  {
                     dashboardListData.dispositionCompleted != 0 ?
                        <Link to={'/all-boxes?status=Dispositon Completed'}>   <Card className="dashboard-card gradient-gold" title={<span className="dashboard-title"> Disposition</span>}>
                           <p className="dashboard-number">{dashboardListData?.dispositionCompleted}</p>
                        </Card>
                        </Link> :
                        <Card className="dashboard-card gradient-gold" title={<span className="dashboard-title">Disposition</span>}>
                           <p className="dashboard-number">{dashboardListData?.dispositionCompleted}</p>
                        </Card>
                  }
               </Col>
               <Col span={4}>
                  {
                     dashboardListData.re_assign_box != 0 ?
                        <Link to={'/all-boxes?status=Re Assign Spec'}>   <Card className="dashboard-card gradient-white" title=
                           {
                              <>
                                 <span style={{ color: 'white', fontWeight: '800', display: 'flex', marginLeft: '-1px' }}> Re Assigned </span>
                                 <span style={{ marginLeft: '20px' }} className="dashboard-title " >Boxes</span>
                              </>

                           }>
                           <p className="dashboard-number">{dashboardListData?.re_assign_box}</p>
                        </Card>
                        </Link> :
                        <Card className="dashboard-card gradient-white" title={
                           <>
                              <span style={{ color: 'white', fontWeight: '800', display: 'flex', marginLeft: '-1px' }}> Re Assigned </span>
                              <span style={{ marginLeft: '20px' }} className="dashboard-title " >Boxes</span>
                           </>

                        }>
                           <p className="dashboard-number">{dashboardListData?.re_assign_box}</p>
                        </Card>
                  }
               </Col>
            </Row>
         </Card>

         <Card
            extra={
               <div
                  style={{
                     display: "flex",
                     justifyContent: "space-between",
                     alignItems: "center",
                     flexWrap: "wrap",
                     gap: "12px",
                     margin: "16px 0"
                  }}
               >
                  {/* Left Side: Search + Buttons */}
                  <div
                     style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        flexWrap: "wrap"
                     }}
                  >
                     <span style={{ fontWeight: 900, fontSize: '19px', marginTop: '1px', marginRight: '720px' }}>Box Event Stages Stats</span>
                     {/* <SearchComponent
                        style={{ width: "300px" }}
                        placeHolder="Search Box Number"
                     />
                     <Button className="primary-btn rounded-4">
                        Search Box Number
                     </Button> */}

                  </div>

                  {/* Right Side: Search Filter Button */}


                  {/* Search Filter Modal */}

               </div>
            }
         >
            <div
               style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(5, 1fr)", // 5 cards in one row
                  gap: "16px",
               }}
            >
               {eventData.map((event) => {
                  const matched = getEventBoxCountData.find(
                     (item) => item.event_id === event.value
                  );

                  return (
                     <>
                        <Card
                           style={{
                              // background: "linear-gradient(to right, rgb(40, 48, 72), rgb(133, 147, 152))",
                              // color: "white",
                           }}
                           styles={{
                              header: {
                                 color: "white", borderBottom: "none", backgroundColor: "#622d44de",
                                 color: "white",
                                 borderBottom: "none",
                                 textAlign: "center",
                              }
                           }}
                           size="small"

                           title={
                              <span className="text-center" style={{ display: "flex", alignItems: "center", gap: "8px", color: "white", }}>
                                 {/* <BsBoxes size={18} /> */}
                                 {event.label}
                              </span>
                           }
                        >
                           {matched ? (
                              <Link to={`/event-boxes/${window.btoa(matched.event_id)}`}>
                                 <p className="text-center" style={{ fontWeight: 900, fontSize: '18px' }}>
                                    {matched.box_count}
                                 </p>
                              </Link>
                           ) : (
                              <p className="text-center" style={{ fontWeight: 900, fontSize: '19px' }}>0</p>
                           )}
                        </Card>

                     </>

                  );
               })}
            </div>


            <Divider />

         </Card>

         <Card
            extra={
               <div
                  style={{
                     display: "flex",
                     justifyContent: "space-between",
                     alignItems: "center",
                     flexWrap: "wrap",
                     gap: "10px",
                     margin: "16px 0"
                  }}
               >
                  {/* Left Side: Search + Buttons */}
                  <div
                     style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        flexWrap: "wrap"
                     }}
                  >
                     <span style={{ fontWeight: 900, fontSize: '19px', marginTop: '1px', marginRight: clearFilter ? '80px' : '200px' }}>Box Stats</span>
                     <SearchComponent
                        onChange={e => {
                           const val = e.target.value;
                           setSearchValue(val);

                           if (!val.trim()) {

                              getData({});
                           }
                        }}
                        style={{ width: "300px" }}
                        placeHolder="Search Box Number"
                        onPressEnter={handleSearchClick}
                     />
                     <Button className="primary-btn rounded-4" onClick={handleSearchClick}>
                        Search Box Number
                     </Button>
                     {clearFilter &&
                        <Button
                           icon={<RedoOutlined />}
                           className="btn btn-danger rounded-4"
                           shape="round"
                           onClick={() => {
                              setClearFilter(false);
                              setSearchText('');
                              setSearchDate(null);
                              searchForm.resetFields();
                              getData({});
                           }
                           }
                        >
                           Clear Filter
                        </Button>
                     }
                     <Button
                        className="primary-btn"
                        icon={<SearchOutlined />}
                        shape="round"
                        type="primary"
                        onClick={() => setSearchModal(true)}
                     >
                        Search Filter
                     </Button>
                  </div>

                  {/* Right Side: Search Filter Button */}


                  {/* Search Filter Modal */}
                  <Modal
                     open={searchModal}
                     onCancel={handleCancel} // Use new cancel handler to reset form
                     okText="Search"
                     // 5. Link the Modal's OK button to the Form submission
                     okButtonProps={{
                        htmlType: 'submit', // This makes the button trigger the form's onFinish
                        form: 'searchFilterForm', // Link it to the Form component's ID
                     }}
                     title={
                        <span>
                           Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                           <hr />
                        </span>
                     }
                     width={600}
                  >
                     {/* 6. Wrap content in Ant Design Form */}
                     <Form
                        form={searchForm} // Pass the form instance
                        id="searchFilterForm" // Important: Give the form an ID
                        onFinish={handleSearch} // This is called when 'Enter' is pressed in an Input or 'Search' is clicked
                        layout="vertical"
                        initialValues={{
                           // Set initial values (e.g., to match external state if applicable, otherwise leave blank)
                           searchText: '',
                           searchDate: null,
                           stage: null,
                           boxStatusValue: null,
                        }}
                     >
                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                           {/* First Line: Spec */}
                           <Form.Item
                              label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Search by Spec</label>}
                              name="searchText" // Use 'name' to map to form values
                              style={{ marginBottom: 0 }}
                           >
                              <Input
                                 placeholder="Enter Spec"
                              // Removed value and onChange, Form manages them now
                              />
                           </Form.Item>

                           {/* Second Line: Pickup Date */}
                           <Form.Item
                              label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Pickup Date</label>}
                              name="searchDate" // Use 'name' for DatePicker
                              style={{ marginBottom: 0 }}
                           >
                              <DatePicker
                                 style={{ width: "100%" }}
                                 placeholder="Select Pickup Date"
                                 format="MM/DD/YYYY"
                              // Removed value and onChange, Form manages them now
                              />
                           </Form.Item>

                           {/* Third Line: Filter By Event Stage */}
                           <Form.Item
                              label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Filter By Event Stage</label>}
                              name="stage"
                              style={{ marginBottom: 0 }}
                           >
                              <Select
                                 options={eventData}
                                 placeholder="Select Event Stage"
                                 allowClear
                              // Removed value and onChange, Form manages them now
                              />
                           </Form.Item>

                           {/* Fourth Line: Filter By Status */}
                           <Form.Item
                              label={<label style={{ marginBottom: "6px", fontWeight: "bold" }}>Filter By Status</label>}
                              name="boxStatusValue"
                              style={{ marginBottom: 0 }}
                           >
                              <Select
                                 options={boxStatus}
                                 placeholder="Select Box Status"
                                 allowClear
                              // Removed value and onChange, Form manages them now
                              />
                           </Form.Item>
                        </div>
                     </Form>
                  </Modal>
               </div>
            }
         >
            <TableComponent columns={boxColumns} dataSource={tableData} size={"small"} />

            <Divider />

         </Card>

      </div>
   );
};

export default DashBoard;
